export default __webpack_public_path__ + "static/media/selecting_the_indicators_2.343902c8.png";